<div class="relative w-full flex-none flex flex-row gap-1 lg:gap-2 justify-between items-center">
  <p class="text-sm lg:text-base text-black dark:text-white font-semibold">Title</p>
  <input
    [(ngModel)]="stickerData.title"
    class="flex justify-center items-center text-center w-full px-2 py-0.5 text-xs lg:text-sm bg-slate-50 dark:bg-white text-gray-700 rounded"
    type="text"
  />
</div>

<div class="flex flex-row justify-between items-center">
  <div class="relative flex flex-row items-center gap-1 lg:gap-2">
    <p class="text-black dark:text-white text-sm lg:text-lg">Sticker Cut</p>
    <div
      class="flex-none w-3 h-3 lg:w-4 lg:h-4 text-black/70 dark:text-white/70 hover:text-black/100 dark:hover:text-white/100"
      matTooltip="By enabling the Sticker Cut feature, you can easily remove stickers from areas where you don't want them by simply clicking on them."
      aria-label="Button that displays a tooltip that can be programmatically disabled"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
        <path
          d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
        />
      </svg>
    </div>
  </div>
  <mat-slide-toggle
    [(ngModel)]="isStickerCutMode"
    (ngModelChange)="changeCutMode()"
  ></mat-slide-toggle>
</div>
<button (click)="onClickDone()" class="w-full px-2 py-1 text-sm bg-gray-700 text-white rounded">
  Done
</button>
